import { render, staticRenderFns } from "./ModifyPasswordModal.vue?vue&type=template&id=1386b758"
import script from "./ModifyPasswordModal.vue?vue&type=script&lang=js"
export * from "./ModifyPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports